import type { SVGProps } from 'react';

// Брендовый вордмарк AGIMA одноцветный (эталоны AIRD-1251): тёмный #272729
// на светлой теме, белый на тёмной — обе темы дают var(--octor-fg).
export function AgimaLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="currentColor"
      overflow="visible"
      preserveAspectRatio="xMinYMid meet"
      viewBox="0 0 1202 261"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M276.923 256.873H186.699C186.702 256.664 186.703 256.455 186.703 256.246C186.703 229.603 165.104 208.004 138.461 208.004C111.818 208.004 90.2197 229.603 90.2197 256.246C90.2197 256.455 90.221 256.664 90.2236 256.873H0L79.2324 5.01172H197.69L276.923 256.873Z" />
      <path d="M390.949 0C457.36 3.73536e-05 501.843 40.6431 516.88 94.834H420.601C412.167 87.6132 401.215 83.25 389.242 83.25C362.599 83.25 341 104.849 341 131.492C341 158.136 362.599 179.734 389.242 179.734C402.02 179.734 413.636 174.764 422.268 166.654H389.383V107.762H517.507V256.874H447.337V240.467C434.421 252.828 414.112 260.633 382.178 260.633C311.381 260.633 256.874 208.632 256.874 130.316C256.874 57.0544 313.142 0 390.949 0Z" />
      <rect height="251.862" width="86.46" x="530.037" y="5.01172" />
      <path d="M776.887 93.9258L791.297 5.01172H924.746V256.873H838.286V131.078L814.478 257.151H739.295L715.487 131.081V256.873H629.027V5.01172H762.477L776.887 93.9258Z" />
      <path d="M1201.92 256.873H1111.7C1111.7 256.664 1111.7 256.455 1111.7 256.246C1111.7 229.603 1090.1 208.004 1063.46 208.004C1036.82 208.004 1015.22 229.603 1015.22 256.246C1015.22 256.455 1015.22 256.664 1015.22 256.873H925L1004.23 5.01172H1122.69L1201.92 256.873Z" />
    </svg>
  );
}
